import { ModuleIOValueTypeEnum, ModuleInputKeyEnum, ModuleTemplateTypeEnum } from '../../constants';
import { FlowNodeInputTypeEnum, FlowNodeTypeEnum } from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

export const SetWxWorkTag: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.setWxWorkTag,
  templateType: ModuleTemplateTypeEnum.tools,
  isTool: true,
  flowType: FlowNodeTypeEnum.setWxWorkTag,
  avatar: '/imgs/module/cfr.svg',
  name: '设置企业微信标签',
  description: '设置企微上该用户的标签',
  inputs: [
    Input_Template_Switch,
    {
      key: ModuleInputKeyEnum.wxworkTags,
      type: FlowNodeInputTypeEnum.cascader,
      label: '要增加的企微标签',
      valueType: ModuleIOValueTypeEnum.string,
      required: true,
      request: 'https://xxxx',
    },
  ],
  outputs: [Output_Template_Finish],
};
